import { useMutation, useQueryClient } from '@tanstack/react-query';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/idp/base';
import type { ActivityStatus } from '@/data/idp/plans/interfaces';

export const useUpdatePlanActivityStatus = (planId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      activityId,
      status,
    }: {
      activityId: string;
      status: ActivityStatus;
    }) =>
      falconClient.patch(
        `${baseUrl}/plans/${planId}/activities/${activityId}/update_status`,
        { status }
      ),
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: [clientKeys.usePlanShow, planId],
      });
      queryClient.refetchQueries({
        queryKey: [clientKeys.usePlanActivitiesIndex, planId],
      });
    },
  });
};
